// @ts-check
import React, { Component } from "react";
import classNames from "classnames";
import TeaserTile, { tileType } from "./TeaserTile/teaser-tile";
import TitleLinkTop from "../Shared/TitleLinkTop/title-link-top";
import PropTypes from "prop-types";
import TeaserGridVideo from "./TeaserGridVideoModal/teaser-grid-video";
import SpinnerButton from "../../ReactComponents/Shared/FormInputs/spinner-button";

export const templateType = {
    T1: "template-1",
    T2: "template-2",
    T3: "template-3",
    T4: "template-4",
    T5: "template-5"
};

const templateTypes = {
    [templateType.T1]: { repeats: true, pattern: [tileType.COL__1] },
    [templateType.T2]: { repeats: true, pattern: [tileType.COL__2] },
    [templateType.T3]: {
        repeats: true,
        pattern: [
            tileType.COL__2,
            tileType.COL__1,
            tileType.COL__1,
            tileType.COL__1,
            tileType.COL__1,
            tileType.COL__2
        ]
    },
    [templateType.T4]: {
        repeats: true,
        pattern: [
            tileType.COL__1,
            tileType.COL__1,
            tileType.COL__2,
            tileType.COL__2,
            tileType.COL__1,
            tileType.COL__1
        ]
    },
    [templateType.T5]: { repeats: false, pattern: [tileType.COL__4] }
};

class TeaserGrid extends Component {
    constructor(props) {
        super(props);

        this.state = {
            videoModalActive: false,
            videoModalUrl: "",
            pageIndex: 0,
            allChunksLoaded: false,
            isLoadingChunk: false,
            teaserListChunks: [this.props.TeaserList.slice(0, this.props.PageSize)],
            isMounted: false
        };

        this.setVideoModal.bind(this);
        this.getVideoAnchorId.bind(this);
        this.loadNextChunk.bind(this);
    }

    setVideoModal(active, url) {
        // If we close modal, remove the hashtag from url
        if (!active && document) history.replaceState({}, document.title, window.location.pathname);

        this.setState({
            videoModalActive: active,
            videoModalUrl: url
        });
    }

    loadNextChunk() {
        // request to WebApiLoadMoreUrl with TagFilter
        if (this.props.WebApiLoadMore) {
            this.setState({ isLoadingChunk: true });

            fetch(this.props.WebApiLoadMoreUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    PageSize: this.props.PageSize,
                    TagFilter: this.props.TagFilter,
                    Page: this.state.pageIndex + 1
                })
            })
                .then(res => (res.ok ? res : Promise.reject(res)))
                .then(res => res.json())
                .then(response => {
                    if (response.Success) {
                        const chunks = Object.assign([], this.state.teaserListChunks);
                        chunks.push(response.Payload.Items);
                        this.setState({
                            teaserListChunks: chunks,
                            pageIndex: this.state.pageIndex + 1,
                            isLoadingChunk: false,
                            allChunksLoaded: !response.Payload.HasNext
                        });
                    } else {
                        this.setState({ allChunksLoaded: true });
                    }
                });
        } else {
            const chunks = Object.assign([], this.state.teaserListChunks);
            chunks.push(
                this.props.TeaserList.slice(
                    (this.state.pageIndex + 1) * this.props.PageSize,
                    (this.state.pageIndex + 1) * this.props.PageSize + this.props.PageSize
                )
            );

            this.setState({
                teaserListChunks: chunks,
                allChunksLoaded: chunks.flatMap(x => x).length >= this.props.TeaserList.length,
                pageIndex: this.state.pageIndex + 1
            });
        }
    }

    getVideoAnchorId(hash) {
        if (hash) {
            // AnchorId-video+props.TeaserList[i].anchorId
            //                                                                                             This part is matched
            //                                                                                                      |
            //                                                                                               |--------------|
            // http://dev.gu.dk/landingpages/landingpage-demos/ExamplePage%20-%20Anchors#teaser-grid-1+video-TeaserGridItem-1
            const match = /\+video-(.*?)$/gm.exec(hash);
            if (match) {
                return match[1];
            }
        }
        return null;
    }

    componentDidMount() {
        this.setState({ isMounted: true });
        const videoAnchorId = this.getVideoAnchorId(document.location.hash);

        if (videoAnchorId && this.props.TeaserList) {
            const videoToPlay = this.props.TeaserList.filter(
                teaserListItem => teaserListItem.VideoAnchorId == videoAnchorId
            ).map(teaserListItem => teaserListItem.VideoUrl)[0];

            if (videoToPlay) this.setVideoModal(true, videoToPlay);
        }
    }

    render() {
        const { pattern, repeats } = templateTypes[this.props.TemplateType] || templateTypes[templateType.T1];
        const getTileType = tileIndex => {
            if (this.props.TeaserList && this.props.TeaserList.length === 1) {
                return tileType.COL__4;
            }

            return repeats ? pattern[tileIndex % pattern.length] : pattern[tileIndex] || tileType.COL__1;
        };

        const baseClass = "teaser-grid";
        const componentClasses = classNames(
            baseClass,
            `${baseClass}--${this.props.TemplateType}`,
            "content-module",
            {
                "content-module--bg": !!this.props.BackgroundColorClass,
                [`${this.props.BackgroundColorClass}--bg`]: !!this.props.BackgroundColorClass,
                "content-module--no-margin-top": this.props.HasNoMarginTop,
                "content-module--no-margin-bottom": this.props.HasNoMarginBottom
            }
        );

        const gridAnchorId = this.props.AnchorId;

        return (
            <section className={componentClasses}>
                <TeaserGridVideo
                    setVideoModal={this.setVideoModal.bind(this)}
                    videoModalActive={this.state.videoModalActive}
                    VideoUrl={this.state.videoModalUrl}
                    title={this.props.Title}
                />

                <div className={`${baseClass}-inner`}>
                    {(this.props.Title || this.props.ViewMoreLink) && (
                        <TitleLinkTop
                            Title={this.props.Title}
                            ViewMoreLink={this.props.ViewMoreLink}
                            TextColorClass={this.props.TextColorClass}
                        />
                    )}
                    {this.props.TeaserList &&
                        this.props.ShowLoadMore &&
                        this.props.PageSize &&
                        this.state.teaserListChunks.map((teaserList, teaserListIndex) => (
                            <div key={teaserListIndex} className={`${baseClass}__items`}>
                                {teaserList.map((item, index) => {
                                    const id =
                                        gridAnchorId && item.videoAnchorId
                                            ? `${gridAnchorId}+video-${item.videoAnchorId}`
                                            : "";

                                    return (
                                        <div key={index} className={`${baseClass}__item`} id={id}>
                                            <TeaserTile
                                                {...item}
                                                focused={
                                                    this.state.isMounted &&
                                                    item.VideoAnchorId != null &&
                                                    item.VideoAnchorId ==
                                                        this.getVideoAnchorId(document.location.hash)
                                                }
                                                parentAnchor={gridAnchorId}
                                                setVideoModal={this.setVideoModal.bind(this)}
                                                tileType={getTileType(index)}
                                            />
                                        </div>
                                    );
                                })}
                            </div>
                        ))}

                    {this.props.TeaserList && !this.props.ShowLoadMore && (
                        <div className={`${baseClass}__items`}>
                            {this.props.TeaserList.map((item, index) => {
                                const id =
                                    gridAnchorId && item.VideoAnchorId
                                        ? `${gridAnchorId}+video-${item.VideoAnchorId}`
                                        : undefined;

                                return (
                                    <div key={index} className={`${baseClass}__item`} id={id}>
                                        <TeaserTile
                                            {...item}
                                            focused={
                                                this.state.isMounted &&
                                                item.VideoAnchorId != null &&
                                                item.VideoAnchorId ==
                                                    this.getVideoAnchorId(document.location.hash)
                                            }
                                            parentAnchor={gridAnchorId}
                                            setVideoModal={this.setVideoModal.bind(this)}
                                            tileType={getTileType(index)}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    )}

                    {this.props.ShowLoadMore && !this.state.allChunksLoaded && (
                        <div className={`${baseClass}__load-more-button-wrapper`}>
                            <SpinnerButton
                                isLoading={this.state.isLoadingChunk}
                                className="button-load-more"
                                onClick={() => this.loadNextChunk()}
                                label={this.props.LoadMoreLabel}
                                type="button"
                            />
                        </div>
                    )}
                </div>
            </section>
        );
    }
}

TeaserGrid.propTypes = {
    Title: PropTypes.string,
    ViewMoreLink: PropTypes.string,
    TemplateType: PropTypes.oneOf(Object.keys(templateType).map(key => templateType[key])).isRequired,
    TeaserList: PropTypes.arrayOf(
        PropTypes.shape({
            ImageSrc: PropTypes.string,
            ImageAltText: PropTypes.string,
            Tag: PropTypes.string,
            Title: PropTypes.string,
            Trumpet: PropTypes.string,
            RichText: PropTypes.string,
            CtaLink: PropTypes.string,
            CtaUrl: PropTypes.string,
            CtaTarget: PropTypes.string,
            ShowCtaAsLink: PropTypes.bool,
            UseCtaAsImageLink: PropTypes.bool,
            VideoUrl: PropTypes.string,
            parentAnchor: PropTypes.string,
            VideoAnchorId: PropTypes.string
        })
    ),
    BackgroundColorClass: PropTypes.string,
    TextColorClass: PropTypes.string,
    HasNoMarginTop: PropTypes.bool,
    HasNoMarginBottom: PropTypes.bool,
    TwentyThreeVideoDomain: PropTypes.string,
    TwentyThreeVideoPlayerId: PropTypes.string,
    AnchorId: PropTypes.string
};

export default TeaserGrid;
